import React from 'react';

class ProjectAssociableSurveyItem {
  constructor(item) {
    if (item === undefined) {
      this.Selected = false;
      this.SurveyId = '';
      this.Name = '';
      this.ActiveProjectNames = '';
      return;
    }
    this.Selected = item.selected;
    this.SurveyId = item.surveyId;
    this.Name = item.name;
    this.ActiveProjectNames = item.activeProjectNames;
  }

  static NameOfTheIdField() {
    return 'SurveyId';
  }

  static editGeneralFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static nameOfTheItemDetailList() {
    return 'Name';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];
  static BoolFields = ['IsUninvoiceable'];
  static FieldsToShowInListTable = [];
  static FieldsToShowInDataTable() {
    return [
      { label: 'Selected', orderById: '', data: ProjectAssociableSurveyItem.getSelectedCellContent, minWidth: 20 },
      { label: 'Survey Id', orderById: 'SassieId', data: 'SassieId', minWidth: 70 },
      { label: 'Name', orderById: 'Name', data: 'Name' },
      { label: 'Current Projects', orderById: 'ActiveProjectNames', data: 'ActiveProjectNames' },
    ];
  }

  static getSelectedCellContent(item) {
    if (item.Selected === undefined) item.Selected = false;
    return (
      <div className='text-center'>
        <input
          type='radio'
          checked={item.Selected}
          onClick={(e) => {
            ProjectAssociableSurveyItem.clickOnSelect(item);
          }}
          onChange={(e) => {}} //Don't remove. This is necessary to eliminate the React warning!
        />
      </div>
    );
  }

  static clickOnSelect(item) {
    alert('Click');
  }
}

export default ProjectAssociableSurveyItem;
